import React, { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { IconButton, Grid, ButtonGroup, Button, Box, useTheme, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Addicon from '@mui/icons-material/Edit';
import Closeicon from '@mui/icons-material/Close';
import { ColorModeContext, tokens } from "../../../theme/theme";
import { useContext } from "react";
import Tooltip from '@mui/material/Tooltip';
import { FormControl, Stack } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormHelperText } from '@mui/material';

const OrderCancel = ({ closePopup, onSubmit }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [Reason, SetReason] = useState('');
  const [selectedDate, setSelectedDate] = React.useState();

  const [ReasonError, setReasonError] = useState("");
  const [DateError, setDateError] = useState("");

  const handleEnterReason = (e) => {
    SetReason(e.target.value);
  }
  const handleDateChange = (date) => {
    const selectedDate = new Date(date); // Assuming 'date' is a valid date string
    const formattedDate = selectedDate.toLocaleDateString('en-US');
    setSelectedDate(formattedDate);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formDirty = false;

    const validateField = (value, setError, errorMessage) => {
      if (!value) {
        setError(errorMessage);
        return true;
      }
      setError("");
      return false;
    };

    formDirty = validateField(Reason, setReasonError, "Cancel Reason is required") || formDirty;
    formDirty = validateField(selectedDate, setDateError, "Cancel Date is required") || formDirty;   

    if (!formDirty) {
      onSubmit(Reason, selectedDate);
      closePopup();
    }
  };

  return (
    <Box component="form" autoComplete="off" style={{ width: '100%' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginLeft: '5px', marginTop: '0px' }}>
        <Typography
          variant="h4"
          fontWeight="600"
          color={colors.grey[100]}>
          Cancel Order
        </Typography>
      </Box>

      <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
        <Grid item xs={18} md={18}>
          <TextField fullWidth size="small" label="Cancel Reason"
            variant="standard" value={Reason} onChange={handleEnterReason}
            error={ReasonError && ReasonError.length ? true : false}
            helperText={ReasonError}
            required />
        </Grid>
      </Grid>

      <Grid container spacing={1} style={{ marginLeft: '0px', marginTop: '1px' }}>
        <Grid item xs={18} md={18}>      
          <FormControl fullWidth size="small" required  error={DateError && DateError.length ? true : false}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <DatePicker
                  label="Cancel date"
                  fullWidth
                  onChange={handleDateChange}
                  slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                  className="customDatePicker"
                  required
                  renderInput={(props) => (
                    <TextField required {...props} variant="standard" />
                  )}
                />
              </Stack>
            </LocalizationProvider>
            {DateError && DateError.length > 0 && (
              <FormHelperText error>{DateError}</FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>

      <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-end' }}>
        <Tooltip title="Update">
          <IconButton onClick={handleSubmit} type="Submit">
            <Addicon />
          </IconButton>
        </Tooltip>
      </div>
    </Box>
  );
};

export default OrderCancel;
